import React from 'react';

import { routeDirectory } from 'modules';
import { Route } from 'react-router-dom';

import { AuthenticationActivity } from './AuthenticationActivity/AuthenticationActivity';
import { ConfirmCodeActivity } from './ConfirmCodeActivity/ConfirmCodeActivity';
import { ForgotPasswordActivity } from './ForgotPasswordActivity/ForgotPasswordActivity';
import { OnboardingCompleteActivity } from './OnboardingCompleteActivity/OnboardingCompleteActivity';
import { OnboardingPaymentActivity } from './OnboardingPaymentActivity/OnboardingPaymentActivity';
import { OnboardingProfileActivity } from './OnboardingProfileActivity/OnboardingProfileActivity';
import { OnboardingUserTypeActivity } from './OnboardingUserTypeActivity/OnboardingUserTypeActivity';
import { ResetPasswordActivity } from './ResetPasswordActivity/ResetPasswordActivity';
import { SignUpActivity } from './SignUpActivity/SignUpActivity';



export const routes = (
  <>
    <Route
      path={routeDirectory.authentication.signup.rawPath}
      element={<SignUpActivity /> } />

    <Route
      path={routeDirectory.authentication.login.rawPath}
      element={<AuthenticationActivity /> } />

    <Route
      path={routeDirectory.authentication.confirmCode.rawPath}
      element={<ConfirmCodeActivity/>} />

    <Route
      path={routeDirectory.authentication.forgotPassword.rawPath}
      element={<ForgotPasswordActivity />} />

    <Route
      path={routeDirectory.authentication.resetPassword.rawPath}
      element={<ResetPasswordActivity />} />

    <Route
      path={routeDirectory.authentication.onboardingUserType.rawPath}
      element={<OnboardingUserTypeActivity />} />

    <Route
      path={routeDirectory.authentication.onboardingProfile.rawPath}
      element={<OnboardingProfileActivity />} />

    <Route
      path={routeDirectory.authentication.onboardingPayment.rawPath}
      element={<OnboardingPaymentActivity />} />

    <Route
      path={routeDirectory.authentication.onboardingComplete.rawPath}
      element={<OnboardingCompleteActivity />} />
  </>
);
